import jsCookie from 'js-cookie';

//  可存储的cookie列表
const cookieList = ['userName', 'jwt'];

/**
 * @param data {Object} cookie的配置项，常用expires：默认为天， path：路径
 */
export function setCookie (name, value, data) {
  if (cookieList.indexOf(name) < 0) {
    console.log('该cookie没有存储权限');
    return;
  }
  return jsCookie.set(name, value, data);
}

export function getCookie (name) {
  if (cookieList.indexOf(name) < 0) {
    console.log('该cookie没有存储权限');
    return;
  }
  return jsCookie.get(name);
}

export function removeCookie (name) {
  if (cookieList.indexOf(name) < 0) {
    console.log('该cookie没有存储权限');
    return;
  }
  return jsCookie.remove(name);
}
